import {
  HandlingUnitIdView,
  LoadIdView,
  SpecialFreightIdView,
  TransportOrderIdView,
  WaybillIdView,
} from '../../../../models';
import { DeliveryNoteParams } from '../../../delivery-note';

export type ShipmentIdView =
  | WaybillIdView
  | LoadIdView
  | TransportOrderIdView
  | SpecialFreightIdView
  | DeliveryNoteParams
  | HandlingUnitIdView;
